import React from 'react'
import { LineChart } from "@carbon/charts-react";
import TableToolbarDownload from '../../common/TableToolbarDownload';
import { Button, MultiSelect, Tooltip } from 'carbon-components-react'
import * as DashboardConstants from './DashboardConstants'

const DashboardLineChart = (props) => {
    const defaultLineGraphOptions = {
        "title": props.modalTitle,
        "axes": {
            "bottom": {
                "title": props.graphXAxisTitle || DashboardConstants.Time,
                "mapsTo": "date",
                "scaleType": props.bottomScaleType || "labels"
            },
            "left": {
                "mapsTo": "value",
                "title": props.graphTitle,
                "scaleType": "linear",
                "percentage": props.isPercentage,
                "ticks": {
                    formatter: function (num) { if (parseInt(num) === num) return num; }
                }
            }
        },
        "curve": "curveMonotoneX",
        "legend": {
            "position": "top",
            "orientation": "horizontal",
            "alignment": "right"
        },
        "data": {
            "loading": props.loading
        },
        "height": props.height ? props.height : "400px",
        "tooltip": {
            "showTotal": props.showTotal === false ? false : true
        },
        "color": {
            "scale": props.colors || null
        },
    };

    const lineGraphHeaders = [{ key: 'group', header: DashboardConstants.Group }, { key: 'date', header: DashboardConstants.Date },
    { key: 'value', header: DashboardConstants.Value }];


    return (
        <>
            {!defaultLineGraphOptions.data.loading && !props.lineGraphData.length ?
                <>
                    <div className="graph-title carbon-display-Regular-20">{props.title}</div>
                    <div>{DashboardConstants.NoDataAvailable}</div>
                </>
                :
                <div className="dashboard-line-graph">
                    <div className="graph-title carbon-display-Regular-20">
                        <div style={{ display: "flex" }}>
                            <div>{props.title}</div>
                            {props.title &&
                                <Tooltip direction="right">
                                    <div style={{ color: "black", fontSize: "14px" }}>
                                        {DashboardConstants.LineChartTooltip}
                                    </div>
                                </Tooltip>
                            }
                        </div>
                        {props.hideDownloadButton !== true && <div className="download-button">
                            <TableToolbarDownload iconDescription={DashboardConstants.Export} rows={props.lineGraphData} headers={lineGraphHeaders} title={props.title} filename={props.downloadFileName || DashboardConstants.Export} label={DashboardConstants.Download} />
                        </div>}
                    </div>
                    <LineChart
                        data={props.lineGraphData}
                        options={defaultLineGraphOptions}>
                    </LineChart>
                </div>
            }
        </>
    );
};

export default DashboardLineChart;
